import { render, staticRenderFns } from "./UrlsTable.vue?vue&type=template&id=99a38f3e"
import script from "./UrlsTable.vue?vue&type=script&lang=js"
export * from "./UrlsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports